// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGLeft = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("path", {
      d: "M18.534.414c-.6-.57-1.55-.55-2.122.052l-10.005 10.5c-.019.02-.029.045-.043.068-.033.051-.063.103-.097.154-.055.083-.12.161-.158.251-.036.09-.044.187-.062.281-.018.094-.047.185-.047.28 0 .095.029.186.047.28.018.094.026.191.062.281.037.09.103.168.158.251.034.051.064.103.097.154.014.023.024.048.043.068l10.005 10.5c.295.31.69.466 1.087.466.372 0 .744-.138 1.035-.414.6-.571.624-1.521.052-2.12L9.566 12l9.02-9.466c.572-.599.548-1.549-.052-2.12",
      id: "left__a"
    })
  }), /*#__PURE__*/_jsx("use", {
    xlinkHref: "#left__a",
    fillRule: "evenodd"
  })]
}));
SVGLeft.displayName = 'SVGLeft';
export default SVGLeft;